import { getImage, getAction, downloadALink, findCenterConfig, normalizeUrlSlashes } from '@/utils'
import Vue from 'vue'
import { h } from 'vue'
import ElImageViewer from 'element-ui/packages/image/src/image-viewer.vue'
Vue.component('el-image-viewer', ElImageViewer)

export default function (conf, defaultValue) {
    const { accept, __config__: config, limit, action: actionUrl } = conf
    const { option: { config: staticConf, api } } = this.$attrs
    const [action, params, headers] = getAction(api.uploadFileUrl)
    const newFileListValue = defaultValue && Array.isArray(defaultValue) && defaultValue.map(item => {
        return {
            name: item.fileName || '无文件名',
            thumbnail_url: item.thumbnail_url,
            url: item.url,
            uid: item.uid,
            centerId: item.centerId
        }
    })
    return {
        attrs: {
            // headers: { ['Authorization']: staticConf.VUE_APP_REQUEST_HEADER_PREFIX + getCookie('Authorization') },
            headers,
            accept: accept && typeof accept === "object" ? accept.join() : accept,
            // 上传回调事件
            'on-success': (response, file) => {
                if (response && response.code === 200) {
                    const newValue = defaultValue || []
                    const url = response.data.downloadUrl
                    let thumbnail_url = ''
                    const { name, uid } = file
                    // 使用正则表达式匹配文件后缀
                    const regex = /(?:\.([^.]+))?$/
                    // 返回捕获组中的文件后缀名，如果没有后缀名，则返回空字符串
                    const type = regex.exec(name)[1] || ""
                    const typeMap = {
                        pdf: "https://tse3-mm.cn.bing.net/th/id/OIP-C.S5q0RORYqnZMWJvhof7roAAAAA?w=156&h=158&c=7&r=0&o=5&dpr=2&pid=1.7",
                        xlsx: "https://tse3-mm.cn.bing.net/th/id/OIP-C.TcwSOOjjlCsaojeAxE6R-QHaHa?w=194&h=194&c=7&r=0&o=5&dpr=2&pid=1.7",
                    }
                    const val = typeMap[type]
                    if (val) thumbnail_url = val
                    // 若有centerId则存
                    let centerId
                    if (window.$centerConfig) {
                        centerId = window.$centerConfig.centerId
                    }
                    newValue.push({
                        fileName: name,
                        thumbnail_url,
                        url: url,
                        centerId,
                        uid
                    })
                    // this.$set(this.conf.__config__, "defaultValue", newValue)
                    this.$emit('input', newValue)
                }
            },
            'on-remove': (file, fileList) => {
                // this.$emit('input', fileList.map(item => {
                //     return {
                //         fileName: item.name,
                //         url: item.url
                //     }
                // }))
                this.$emit('input', defaultValue.filter(item => {
                    return item.uid !== file.uid
                }))
            },
            // 'list-type': conf["list-type"] ? conf["list-type"] : "picture",
            'list-type': "text",
            'file-list': newFileListValue,
            'on-exceed': () => {
                this.$message.error(`最多上传${limit}个文件`)
                return false
            },
            'before-upload': file => {
                const { type } = file
                const _type = type.split("/")
                const _accept = accept && typeof accept === "object" ? accept.join() : accept
                if (_accept && _accept.includes("image/*") && _type[0] !== "image") {
                    this.$message.error("请上传图片！")
                    return false
                }
                let sizeUnitNum = 1
                // 文件大小判断
                switch (config.sizeUnit) {
                    case "KB":
                        sizeUnitNum = 1024;
                        break;
                    case "MB":
                        sizeUnitNum = 1024 * 1024;
                        break;
                    case "GB":
                        sizeUnitNum = 1024 * 1024 * 1024;
                        break;
                }
                const totalSize = config.fileSize * sizeUnitNum
                if (file.size > totalSize) {
                    this.$message.error(
                        `上传文件大小不能超过${config.fileSize}${config.sizeUnit}`
                    );
                    return false
                }
            },
            'on-preview': file => {
                let { name, url } = file
                // 存在centerId 并且 有$centerConfig配置
                if (file.centerId && window.$centerConfig) {
                    const hostApi = findCenterConfig(file.centerId, window.$centerConfig)
                    if (hostApi) {
                        url = normalizeUrlSlashes(hostApi + url)
                    } else {
                        console.error('未找到对应的centerId')
                    }
                }
                console.log(url)
                let _url
                Array.isArray(defaultValue) && defaultValue.forEach((item) => {
                    if (item.fileName === name) _url = item._url
                })
                const regImg = /\.(jpg|png|gif|bmp|jpeg)$/
                const regVideo = /\.(mp4|mov|avi|mkv|webm)$/
                const flag = _url ? regImg.test(name || _url) : regImg.test(name || url)
                if (flag) {
                    //图片
                    const imgPreview = Vue.extend({
                        data() {
                            return {
                                showViewer: true
                            }
                        },
                        render(h) {
                            return this.showViewer ? h('el-image-viewer', { props: { onClose: () => this.showViewer = false, urlList: [getImage(url)] }, style: { zIndex: 9999 } }, undefined) : null
                        }
                    })
                    const initInstance = () => {
                        new imgPreview({
                            el: document.createElement('div')
                        });
                    }
                    initInstance()
                } else if (regVideo.test(name || _url) || regVideo.test(name || url)) {
                    // 视频
                    window.open(window.location.origin + getImage(url))
                } else {
                    this.$confirm(`${name}`, '文件预览或下载', {
                        distinguishCancelAndClose: true,
                        confirmButtonText: '下载',
                        cancelButtonText: '预览'
                    }).then(() => {
                        // 文件下载
                        downloadALink(_url || url, name)
                    }).catch(action => {
                        if (action === 'cancel') {
                            // 如果是相对路径，则 拼接一下前缀
                            if(url.startsWith("/eventProductApi")){
                                url =window.location.origin + url;
                            }
                            window.open(
                                'https://sjzs.pinghu.gov.cn:41000/sjzs-kkfile/onlinePreview?url=' +
                                encodeURIComponent(window.btoa(url))
                            );
                        }
                    })
                }
            },
            'action': (typeof (action) === 'function' ? action() : action) || actionUrl, // 优先使用option.api.uploadFileUrl, 若无则使用设计器中配置再json中的action
        }
    }
}